import { render, staticRenderFns } from "./AnosafraBrandPercentages.vue?vue&type=template&id=8098674e"
import script from "./AnosafraBrandPercentages.vue?vue&type=script&lang=js"
export * from "./AnosafraBrandPercentages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports